import { EmployeeAvatar } from '@newfront-insurance/core-ui';
import { Skeleton } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';

import { getNameInitials } from './settings-people/employee-utils';
import { SettingsSectionListRow } from './settings-section-list';

/** The person-specific adapter supplies the avatar; the list row owns layout. */
export function SettingsPersonRow({
  name,
  description,
  imageUrl,
  initials,
  badges,
  action,
  loadingLabel,
}: {
  name?: string;
  description?: string;
  imageUrl?: string;
  initials?: string;
  badges?: ReactNode;
  action?: ReactNode;
  loadingLabel?: string;
}) {
  return (
    <SettingsSectionListRow
      title={name}
      description={description}
      loadingLabel={loadingLabel}
      trailing={
        badges ? (
          <div className="flex flex-wrap items-center justify-end gap-4">
            {badges}
            {action}
          </div>
        ) : (
          action
        )
      }
      leading={
        loadingLabel ? (
          <Skeleton aria-hidden="true" className="bg-steel-100 size-9 rounded-full" />
        ) : (
          <EmployeeAvatar sizeInPixels={36} imageUrl={imageUrl} initials={initials ?? getNameInitials(name ?? '')} />
        )
      }
    />
  );
}
